import { apiErrorsToDict } from 'src/types/api-error-response';

const MAX_LENGTH = 300;

/**
 * Turns an RTK Query error into a toast message: the server's validation messages
 * when present, otherwise the given fallback.
 */
export const describeApiError = (error: unknown, fallback: string): string => {
  const dict = apiErrorsToDict(error);
  if (!dict) return fallback;
  const messages = Object.values(dict)
    .filter(Boolean)
    .map((m) => m.split('\n')[0].trim());
  const joined = messages.join(' ');
  if (!joined) return fallback;
  const capped = joined.length > MAX_LENGTH ? `${joined.slice(0, MAX_LENGTH)}…` : joined;
  return `${fallback}: ${capped}`;
};
